import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AnalyticsService } from '../../core/services/analytics-service';
import { DialogService } from '../../core/services/dialog.service';
import { Component, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { switchMap, tap, filter } from 'rxjs/operators';
import { AnalyticsEvent } from 'src/app/core/services/analytics-service';
import { MAX_WIDTH_90, WIDTH_360 } from 'src/app/shared/configs/dialog-config';
import {
  PhoneNumberEditDialogComponent,
  PHONE_VERIFIED_EVENT,
} from '../phone-number-edit-dialog/phone-number-edit-dialog.component';

@Component({
standalone: false,
  selector: 'app-unverified-customer-dialog',
  styleUrls: ['./unverified-customer-dialog.component.scss'],
  templateUrl: './unverified-customer-dialog.component.html',
})
export class UnverifiedCustomerDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: UnverifiedCustomerDialogData,
    private router: Router,
    private dialogService: DialogService,
    private analyticsService: AnalyticsService,
  ) {}

  public goBack(): void {
    this.data?.returnUrl ?? this.router.navigateByUrl(this.data?.returnUrl);
  }

  public verifyPhoneNumber = (): Observable<boolean> =>
    this.dialogService
      .open(PhoneNumberEditDialogComponent, {
        maxWidth: MAX_WIDTH_90,
        width: WIDTH_360,
      })
      .afterClosed()
      .pipe(
        filter((data) => !!data),
        tap(() => this.analyticsService.trackEvent(new AnalyticsEvent(PHONE_VERIFIED_EVENT, { fromChecklist: true }))),
        switchMap(() => {
          if (this.data?.returnPath) {
            return this.router.navigateByUrl(this.data?.returnPath);
          } else if (this.data?.action) {
            return this.data.action;
          }
        }),
      );
}

export interface UnverifiedCustomerDialogData {
  returnUrl?: string;
  returnPath?: string;
  action?: Observable<boolean>;
}
